export class RadioSettings {
  constructor() {
    let overrides = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    const defaults = {
      align: 'row',
      width: {
        type: 'auto',
        value: 1
      },
      height: {
        type: 'auto',
        value: 1
      },
      padding: {
        paddingTop: 2,
        paddingBottom: 2,
        paddingLeft: 2,
        paddingRight: 2
      },
      margin: {
        marginTop: 2,
        marginBottom: 2,
        marginLeft: 2,
        marginRight: 2
      },
      font: {
        fontSize: 12,
        fontWeight: 400,
        color: 'black',
        fontFamily: 'arial, helvetica, sans-serif'
      },
      required: false,
      isBooleanOption: true,
      fieldName: '',
      labelValue: 'Label',
      labelPosition: 'top',
      label: {
        color: 'black',
        fontSize: 12,
        padding: 4,
        fontWeight: 600
      },
      inputs: [{
        label: 'Yes',
        value: true,
        isDefaultSelection: true,
        languages: {}
      }, {
        label: 'No',
        value: false,
        languages: {}
      }],
      languages: {},
      selectedLanguage: ''
    };
    Object.assign(this, defaults, overrides);
  }
}
;
export const RadioTypes = {
  settings: {
    required: {
      title: 'Required',
      type: 'Switch'
    },
    fieldName: {
      title: 'Field Name*',
      type: 'Input'
    }
  },
  label: {
    labelValue: {
      title: 'Label Value',
      type: 'InputLanguage'
    },
    labelPosition: {
      title: 'Label Position',
      type: 'LabelPosition'
    }
  },
  inputs: {
    align: {
      title: 'Radio Input Direction',
      type: 'Direction'
    },
    inputs: {
      title: 'Inputs',
      type: 'SetInputOptions'
    }
  },
  size: {
    width: {
      title: 'Width',
      type: 'Size'
    },
    height: {
      title: 'Height',
      type: 'Size'
    }
  },
  spacing: {
    padding: {
      title: 'Padding',
      type: 'Padding'
    },
    margin: {
      title: 'Margin',
      type: 'Margin'
    }
  }
};